// in src/authProvider.js
import decodeJwt from 'jwt-decode';
import { AuthProvider, } from 'ra-core';
import fetchJson from './utils/fetchJson';

if ('development' === process.env.NODE_ENV) {
  (window as any)['decodeJwt'] = decodeJwt;
  (window as any)['fetchJson'] = fetchJson;
}
//
const AccessControlArray = ['deny', 'neutral', 'allow'] as const;
type AccessControlValue = typeof AccessControlArray[number];
//
const CrudAccessControlActionKeysArray = ['create', 'read', 'update', 'delete'] as const;
type CrudAccessControlActionKeys = typeof CrudAccessControlActionKeysArray[number];
type BaseCrudAccessControl<prop> = { [key in CrudAccessControlActionKeys]: prop; }
type ResourceCrudAccessControl = { [resource: string]: CrudAccessControl };
export type Permissions = {
  role: string,
  permissions: ResourceCrudAccessControl,
}
//
interface CrudAccessControl extends BaseCrudAccessControl<boolean> {
}
interface AccessControl {
  id: number, organization_id: number, alias: string,
}
interface UserAccessControl extends BaseCrudAccessControl<AccessControlValue> {
  id: number, user_id: number, priority: number,
  access_control_id: AccessControl
}
interface fetchJsonResult {
  status: number;
  headers: Headers;
  body: string;
  json: any;
}
export interface DecodedToken {
  readonly iat: string,
  readonly naf: number,
  readonly exp: number,
  //
  readonly id: number,
  readonly username: string,
  readonly email: string,
  readonly role: string,
  //
  readonly simple_acl: string,
  simpleAclByResource: { [resource: string]: { action: Array<string> } }
}
export type AuthProviderEx = AuthProvider & {
  getDecoded: () => DecodedToken | null;
  refreshToken: () => Promise<void>;
  changePassword: (username: string, password: string, newPassword: string) => Promise<fetchJsonResult>;
  impersonate: (username: string, periodInMinutes?: number) => Promise<fetchJsonResult>;
}
interface UacResponse {
  //
  readonly ac: Array<AccessControl>,
  readonly uac: Array<UserAccessControl>,
}

const authProvider = (url: string): AuthProviderEx => {
  //
  if (null === window.sessionStorage.getItem('client_session_id')) {
    if (window.opener && null !== window.opener.sessionStorage.getItem('client_session_id') && -1 === window.location.search.indexOf('new_login')) {
      window.sessionStorage.setItem('client_session_id', window.opener.sessionStorage.getItem('client_session_id'));
    } else {
      window.sessionStorage.setItem('client_session_id', (Math.random() + 1).toString(36).substring(2, 10));
    }
  }
  let decodedToken: null | DecodedToken = null;
  let refreshTokenTimeout: null | NodeJS.Timeout;

  const AutoRefreshIntervalSeconds = 5 * 60;
  setInterval(() => {
    if (null !== localStorage.getItem('refresh_token')) {
      let decodedRefreshToken: { exp: number } = decodeJwt(localStorage.getItem('refresh_token') as string);
      if (((decodedRefreshToken.exp + AutoRefreshIntervalSeconds) * 1000) > Date.now()) {
        ap.refreshToken();
      }
    }
  }, AutoRefreshIntervalSeconds * 1000);

  //
  const ap = {
    login: async function({ username, password }: { username: string, password: string }) {
      const request = new Request(`${url}/login`, {
        method: 'POST',
        body: JSON.stringify({ username, password }),
        headers: new Headers({ 'Content-Type': 'application/json' }),
      });
      try {
        const response = await fetch(request);
        if (response.status < 200 || response.status >= 300) {
          throw new Error(response.statusText);
        }
        const auth = await response.json();
        console.log(auth);
        localStorage.removeItem('permissions');
        localStorage.removeItem('token');
        localStorage.removeItem('refresh_token');
        localStorage.setItem('auth', JSON.stringify(auth));
        await this.refreshToken(true);
        return auth;
      } catch (e) {
        console.warn(e);
        throw new Error('Network error');
      }
    },
    checkError: (error: any) => {
      const status = error.status;
      if (status === 401 || status === 403) {
        console.log('checkError', 'remove');
        localStorage.removeItem('auth');
        localStorage.removeItem('permissions');
        localStorage.removeItem('token');
        localStorage.removeItem('refresh_token');
        return Promise.reject();
      }
      // other error code (404, 500, etc): no need to log out
      return Promise.resolve();
    },
    checkAuth: async function() {
      // if (null !== localStorage.getItem('auth')) {
      if (null === decodedToken) {
        if (null === localStorage.getItem('token')) {
          await this.refreshToken();
        } else {
          decodedToken = decodeJwt(localStorage.getItem('token') as string);
          ap.parseSimpleAcl();
        }
      }

      if (null !== decodedToken && (decodedToken.exp * 1000) > Date.now()) {
        // console.log('checkAuth decodedToken not expired');
        return Promise.resolve();
      } else if (null !== localStorage.getItem('refresh_token')) {
        // console.log('checkAuth null !== refresh_token');
        let decodedRefreshToken: { exp: number } = decodeJwt(localStorage.getItem('refresh_token') as string);
        // console.log('checkAuth decodedRefreshToken.exp', decodedRefreshToken.exp * 1000, Date.now());
        if ((decodedRefreshToken.exp * 1000) > Date.now()) {
          await this.refreshToken();
          // console.log('checkAuth this.refresh_token()');
          return Promise.resolve();
        } else {
          // console.log('checkAuth refresh token expired?');
        }
      }
      // }

      return Promise.reject();
    },
    logout: () => {
      if (refreshTokenTimeout) {
        clearTimeout(refreshTokenTimeout);
      }
      localStorage.removeItem('auth');
      localStorage.removeItem('permissions');
      localStorage.removeItem('refresh_token');
      localStorage.removeItem('token');

      return Promise.resolve();
    },
    getIdentity: () => {
      try {
        const { id, username, email } = decodeJwt(localStorage.getItem('token') as string) as DecodedToken;
        return Promise.resolve({ id, username, email });
      } catch (error) {
        return Promise.reject(error);
      }
    },
    getPermissions: () => {
      let storedPermissions = localStorage.getItem('permissions');
      if (null !== storedPermissions) {
        const permissionsRS: Permissions = JSON.parse(storedPermissions);
        return permissionsRS ? Promise.resolve(permissionsRS) : Promise.reject();
      } else {
        return Promise.reject();
      }
    },
    // Extra
    getDecoded: () => decodedToken,
    refreshToken: async function(force: boolean = false) {
      if (!force && null === localStorage.getItem('refresh_token')) {
        return;
      }
      // console.log('refreshToken 1', );
      const { json: { token, refresh_token } } = await fetchJson(`${url}/auth/token`, {
        // method: 'POST',
        // body: JSON.stringify({
        // 'refresh_token': JSON.parse(localStorage.getItem('refresh_token') as string),
        // 'client_session_id': window.sessionStorage.getItem('client_session_id') as string,
        // })
      });
      // console.log('refreshToken 2', );
      decodedToken = decodeJwt(token) as DecodedToken;
      ap.parseSimpleAcl();
      // let permissions: ResourceCrudAccessControl = {};
      if (null === decodedToken) {
        this.logout();
        return;
      }

      console.log('decodedToken', decodedToken);

      refreshTokenTimeout = setTimeout(this.refreshToken, decodedToken.exp * 1000 * 9);

      const { json: uacResponse } = await fetchJson(`${url}/auth/access-control`, {

      });
      let permissions = ('system_admin' === decodedToken.role) ? ap.buildPermission.allAllow(uacResponse) : ap.buildPermission.affirmative(uacResponse);
      //
      // console.log('permissions', permissions);
      // localStorage.setItem('permissions', JSON.stringify(permissions));
      localStorage.setItem('permissions', JSON.stringify({
        role: decodedToken.role,
        permissions: permissions as ResourceCrudAccessControl,
      } as Permissions));
      localStorage.setItem('token', token);
      localStorage.setItem('refresh_token', refresh_token);

      return;
    },
    changePassword: async (username: string, password: string, newPassword: string) => {
      return await fetchJson(`${url}/auth/change-password`, {
        method: 'POST',
        body: JSON.stringify({ username, password, newPassword }),
        headers: new Headers({ 'Content-Type': 'application/json' }),
      });
    },
    impersonate: async (username: string, periodInMinutes: number = 30) => {
      return await fetchJson(`${url}/auth/impersonate`, {
        method: 'POST',
        body: JSON.stringify({ username, periodInMinutes }),
        headers: new Headers({ 'Content-Type': 'application/json' }),
      });
    },
    parseSimpleAcl: () => {
      if (decodedToken) {
        try {
          decodedToken.simpleAclByResource = Object.fromEntries(JSON.parse(decodedToken.simple_acl).map(({ resource, ...rest }) => ([resource, rest])));
        } catch (e) {

        }
      }
    },
    isSimpleAclAllowed: (resource: string) => {
      // console.log('isSimpleAclAllowed', resource,  ap._isSimpleAclAllowed(resource));
      return ap._isSimpleAclAllowed(resource);
    },
    _isSimpleAclAllowed: (resource: string) => {
      if (decodedToken) {
        if ('system_admin' === decodedToken.role) {
          return true;
        } else if ('admin' === decodedToken.role && decodedToken.simpleAclByResource && decodedToken.simpleAclByResource[resource] && -1 !== decodedToken.simpleAclByResource[resource].action.indexOf('list')) {
          return true;
        } else {
          return false;
        }
      }
    },
    buildPermission: {
      // allAllow (System Admin)
      allAllow: (uacResponse: UacResponse) => {
        let permissions: ResourceCrudAccessControl = {};
        uacResponse.ac.forEach(ac => permissions[ac.alias] = { create: true, read: true, update: true, delete: true, });
        return permissions;
      },
      // affirmative (either)
      affirmative: (uacResponse: UacResponse) => {
        let permissions: ResourceCrudAccessControl = {};
        uacResponse.ac.forEach(ac => permissions[ac.alias] = { create: false, read: false, update: false, delete: false, });
        uacResponse.uac.forEach(uac => {
          CrudAccessControlActionKeysArray.forEach((action) =>
            permissions[uac.access_control_id.alias][action] = ((uac)[action] === 'allow') ?? permissions[uac.access_control_id.alias][action]
          )
        });
        return permissions;
      },
      // consensus (polling)
      consensus: (uacResponse: UacResponse) => {
        let permissions: ResourceCrudAccessControl = {};
        let permissionsStats: { [resource: string]: BaseCrudAccessControl<{ [key in AccessControlValue]: number }> } = {};
        uacResponse.ac.forEach(ac => {
          permissions[ac.alias] = { create: false, read: false, update: false, delete: false, };
          permissionsStats[ac.alias] = { create: { deny: 0, allow: 0, neutral: 0 }, read: { deny: 0, allow: 0, neutral: 0 }, update: { deny: 0, allow: 0, neutral: 0 }, delete: { deny: 0, allow: 0, neutral: 0 }, };
        });
        uacResponse.uac.forEach(uac =>
          CrudAccessControlActionKeysArray.forEach((action) =>
            AccessControlArray.forEach(ac =>
              (permissionsStats[uac.access_control_id.alias])[action][ac] += ((uac)[action] === ac) ? 1 : 0
            )
          )
        )
        uacResponse.uac.forEach(uac =>
          CrudAccessControlActionKeysArray.forEach((action) =>
            permissions[uac.access_control_id.alias][action] = permissionsStats[uac.access_control_id.alias][action]['allow'] > permissionsStats[uac.access_control_id.alias][action]['deny']
          ))
        return permissions;
      },
      // unanimous (no voter deny)
      unanimous: (uacResponse: UacResponse) => {
        let permissions: ResourceCrudAccessControl = {};
        uacResponse.ac.forEach(ac => permissions[ac.alias] = { create: true, read: true, update: true, delete: true, });
        uacResponse.uac.forEach(uac => {
          CrudAccessControlActionKeysArray.forEach((action) =>
            permissions[uac.access_control_id.alias][action] = ((uac)[action] === 'deny') ? false : permissions[uac.access_control_id.alias][action]
          )
        });
        return permissions;
      },
      // priority (first voter)
      priority: (uacResponse: UacResponse) => {
        let permissions: ResourceCrudAccessControl = {};
        let permissionsVoted: ResourceCrudAccessControl = {};
        uacResponse.ac.forEach(ac => {
          permissions[ac.alias] = { create: false, read: false, update: false, delete: false, }
          permissionsVoted[ac.alias] = { create: false, read: false, update: false, delete: false, }
        });

        uacResponse.uac.forEach(uac => {
          CrudAccessControlActionKeysArray.forEach((action) => {
            if ((false === (permissionsVoted[uac.access_control_id.alias])[action]) && ((uac)[action] !== 'neutral')) {
              (permissionsVoted[uac.access_control_id.alias])[action] = true;
              permissions[uac.access_control_id.alias][action] = ((uac as any)[action] === 'allow')
            }
          })
        });
        return permissions;
      },
    }
  }
  return ap;
};

export default authProvider;
